var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",on:{"click":function($event){_vm.loginValidate()}}},[_c('v-img',{key:_vm.item.img.url,attrs:{"item":_vm.item,"img":_vm.item.img,"is-video":_vm.isVideo}}),_vm._v(" "),_c('h5',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.item.title)}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-228eee86","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/front/Card.vue
// module id = 5aoS
// module chunks = 72